// extracted by mini-css-extract-plugin
export default {"layerManagerDialog":"LayerManagerDialog-module__layerManagerDialog__pMkE0","layerManagerDialogDimensions":"LayerManagerDialog-module__layerManagerDialogDimensions__z+WVD"};